<template>
  <div class="app-container">
    <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-select v-model="locale" @change="resetList">
              <el-option v-for="e in i18nConfig.locales" :key="e" :label="e" :value="e"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.status" @change="resetList" clearable placeholder="上下架">
              <el-option label="上架" value="AVAILABLE"></el-option>
              <el-option label="下架" value="UNAVAILABLE"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="resetList" type="primary">查询</el-button>
          <el-button @click="openDialog">新增</el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table ref="table" :data="list" v-loading="listLoading">
        <el-table-column align="left" type="index" width="60" label="#"></el-table-column>
        <el-table-column align="center" label="content" prop="description" min-width="180" />
        <el-table-column align="center" label="title" prop="title" min-width="220" />
        <el-table-column align="center" label="createTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.createTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="updateTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.updateTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="上下架" width="100" fixed="right">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="handleUpdate(scope.row)"
              active-value="AVAILABLE"
              inactive-value="UNAVAILABLE"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button @click="openDialog(scope.row)" type="primary" size="mini"> 编辑 </el-button>
            <el-button @click="handleDelete(scope.row)" size="mini" type="danger"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.current"
          :total="listTotal"
          :page-sizes="[10, 20, 30, 50]"
        />
      </div>
    </div>

    <el-dialog :title="currentRow.id ? '编辑' : '新增'" :visible.sync="dialogVisible" width="500px">
      <el-form class="post-main-container post-dialog-container" label-position="right">
        <el-form-item label="content：" required>
          <el-input v-model.trim="currentRow.description" />
        </el-form-item>
        <el-form-item label="title：" required>
          <el-input v-model.trim="currentRow.title" />
        </el-form-item>
        <el-form-item label="url：" required>
          <el-input v-model.trim="currentRow.url" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" :loading="btnLoading" @click="postEdit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLinks, updateLink, deleteLink } from '@/api/links'
import { i18nConfig } from '@/utils'

const defaultRow = {
  title: '',
  url: '',
  description: '',
  status: 'UNAVAILABLE'
}

export default {
  data() {
    return {
      i18nConfig,
      list: [],
      listTotal: null,
      listLoading: true,

      query: {
        content: '',
        limit: 10,
        current: 1
      },

      locale: i18nConfig.defaultLocale,

      btnLoading: false,
      dialogVisible: false,
      currentRow: {}
    }
  },

  mounted() {
    this.resetList()
  },

  methods: {
    openDialog(row) {
      const copyData = row.id ? row : defaultRow
      this.currentRow = JSON.parse(JSON.stringify(copyData))
      this.dialogVisible = true
    },

    postEdit() {
      if (!this.currentRow.description || !this.currentRow.title || !this.currentRow.url) return
      const form = JSON.parse(JSON.stringify(this.currentRow))
      this.btnLoading = true
      this.handleUpdate(form)
        .then(() => {
          this.dialogVisible = false
        })
        .finally(() => {
          this.btnLoading = false
        })
    },

    handleDelete(row) {
      const { id, description } = row
      this.$confirm(`是否删除友情链接 ${description}`, '提示', {}).then(() => {
        deleteLink(id, this.locale).then(() => {
          this.getList()
        })
      })
    },

    handleUpdate(row) {
      return new Promise((resolve, reject) => {
        updateLink(row, this.locale)
          .then(() => {
            this.getList()
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    resetList() {
      this.query.current = 1
      this.getList()
    },

    getList() {
      this.listLoading = true
      getLinks(this.query, this.locale).then((res) => {
        this.list = res.result.rows
        this.listTotal = +res.result.total
        this.listLoading = false
      })
    },

    handleSizeChange(val) {
      this.query.limit = val
      this.resetList()
    },

    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    }
  }
}
</script>
